import axios from "../lib/axios";

export const addEducation = async (data) => {
  try {
    const response = await axios.post("/education/add", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create education"
    );
  }
};

export const getAllEducationsAdmin = async () => {
  try {
    const response = await axios.get("/education/admin/all");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch educations (admin)"
    );
  }
};

export const getActiveEducations = async ({
  page = 1,
  limit = 10,
  degreeId,
}) => {
  try {
    const response = await axios.get("/education/all", {
      params: {
        page,
        limit,
        degreeId,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch active educations"
    );
  }
};

export const updateEducationAdmin = async (id, payload) => {
  try {
    const response = await axios.patch(`/education/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update education"
    );
  }
};

export const deleteEducationAdmin = async (id) => {
  try {
    const response = await axios.delete(`/education/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete education"
    );
  }
};
